import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import posthog, { PostHogConfig } from 'posthog-js';

/**
 * Internal SSR-safe wrapper around the PostHog SDK — the SOLE importer of `posthog-js`. Not exported from the
 * entry point's public API: components go through {@link AnalyticsService}, never this directly. Before `init`
 * (or off-browser) the `posthog` getter returns a no-op Proxy so every call is a safe no-op (e.g. in tests/SSR).
 */
@Injectable({ providedIn: 'root' })
export class PosthogService {
  private readonly platformId = inject(PLATFORM_ID);
  private initialized = false;

  get posthog(): typeof posthog {
    if (isPlatformBrowser(this.platformId) && this.initialized) {
      return posthog;
    }
    return new Proxy({} as typeof posthog, {
      get: () => () => undefined
    });
  }

  init(apiKey: string, options: Partial<PostHogConfig>): void {
    if (isPlatformBrowser(this.platformId) && !this.initialized) {
      posthog.init(apiKey, options);
      this.initialized = true;
    }
  }
}
